import { companyService } from 'ogp/services';
import { useMutation } from 'react-query';
import { CompanySSOSettingsForm } from './edit-company-sso.types';

export const useUpdateSSOSettings = () => {
  const mutationFn = async (payload: CompanySSOSettingsForm) => {
    const [ogpXml, workerXml] = await Promise.all([
      payload.ogpMetadataFile?.text() ?? Promise.resolve(undefined),
      payload.workerMetadataFile?.text() ?? Promise.resolve(undefined),
    ]);
    return companyService.updateSSOSettings({
      ogpSsoSettings: {
        emailClaim: payload.ogpSamlAttribute,
        xmlData: ogpXml ?? '',
        isEnabled: payload.ogpSsoEnabled,
      },
      workerSsoSettings: {
        emailClaim: payload.workerSamlAttribute,
        xmlData: workerXml ?? '',
        isEnabled: payload.workerSsoEnabled,
      },
    });
  };

  return useMutation(mutationFn, {});
};
